import React, { FC, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../components/general/Icon';
import { Label } from '../../../components/general/forms/Label';
import { Colors } from '../../../styles/colors';

export interface FilterListInputProps {
  id: string;
  label?: string;
  value?: string | null;
  onChange: (value: string | null) => void;
  placeholder?: string;
}

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InputOuterWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  overflow: visible;
`;

export const InputInnerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  overflow: hidden;
`;

const DropDownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
`;

const OpenSelectButton = styled.button`
  background-color: ${Colors.primary};
  width: 3.625rem;
  padding: 1rem;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledInput = styled.input`
  text-indent: 1px;
  text-overflow: '';
  border: none;
  color: ${Colors.gray};
  background-color: ${Colors.white};
  font-size: 0.875rem;
  padding: 0 4.625rem 0 1rem;
  flex: 1;
  min-height: 3.625rem;
  
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${Colors.gray};
    font-size: 0.875rem;
  }

  &:focus {
    outline: none;
  }
  
  &:hover {
    cursor: pointer;
  }
`;

export const FilterListInput: FC<FilterListInputProps> = (props) => {
  const { value, onChange } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <InputWrapper>
      <Label for={props.id}>
        {props.label}
      </Label>
      <DropDownWrapper
        ref={wrapperRef}>
        <InputOuterWrapper>
          <InputInnerWrapper>
            <StyledInput
              type={'text'}
              id={props.id}
              autoComplete={'off'}
              placeholder={`${props.placeholder ? props.placeholder : 'Hier eingeben'}`}
              value={value}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                if (onChange) {
                  onChange(event.target.value || null);
                }
              }}>
            </StyledInput>
            <OpenSelectButton>
              <Icon
                icon={'search'}
                size={24}
                color={Colors.white}/>
            </OpenSelectButton>
          </InputInnerWrapper>
        </InputOuterWrapper>
      </DropDownWrapper>
    </InputWrapper>
  );
};
